// CANONICAL COPY (GH #7115). src/constants/obligations/obl-records-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-records-protection',
  title: 'Review records and data protection controls',
  description:
    'Verify that records and information are protected from loss, destruction, falsification, unauthorised access and unauthorised release in accordance with legal and business requirements. Review technical and organisational measures applied to sensitive data at rest and in transit.',
  category: 'compliance',
  scfIds: ['SCF-DAT-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Records and data protection policy is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
